import React, { useCallback } from 'react'
import { Modal } from '@manychat/manyui'

import { Confirm3DS } from 'common/billing/components/Confirm3DS'
import { promiseRender } from 'common/billing/helpers/promiseRender'
import { CancelError } from 'shared/api/lib/errors/business/local'

const CANCEL_ERROR = 'Rejected 3DS confirmation'
const MODAL_WIDTH = 640

export const [confirm3DS, AsyncConfirm3DS] = promiseRender<void>(({ resolve, reject }) => {
  const handleClose = useCallback(() => {
    reject(new CancelError(CANCEL_ERROR))
  }, [reject])

  return (
    <Modal disableClose open onRequestClose={handleClose} width={MODAL_WIDTH}>
      <Confirm3DS onConfirm={resolve} className="p-y-md" />
    </Modal>
  )
})
